// extracted by mini-css-extract-plugin
module.exports = {"listeSpesialmodul":"dhsgzx_8F-listeSpesialmodul","kort":"dhsg2s26c-kort","gradientLeft":"dhsg3f0KC-gradientLeft","gradientRight":"dhsgopb-Z-gradientRight"};